import { SyntheticEvent, useState, useEffect } from 'react'
import { ReactPaginateProps } from 'react-paginate'

export interface Props {
  page: number
  pageTotal: number
  onChangePage: ({ selected }: { selected: number }) => void
}

export const usePagination = (props: Props) => {
  const { page, pageTotal } = props
  const [currentPage, setCurrentPage] = useState(props.page - 1)
  const onChangePage = ({ selected }: { selected: number }) => {
    props.onChangePage({
      selected: selected + 1,
    })
  }
  const isFirst = currentPage === 0
  const isLast = currentPage === pageTotal - 1
  const onClickFirst = (e: SyntheticEvent) => {
    e.preventDefault()

    if (isFirst) {
      return
    }

    setCurrentPage(0)
    props.onChangePage({
      selected: 1,
    })
  }
  const onClickLast = (e: SyntheticEvent) => {
    e.preventDefault()

    if (isLast) {
      return
    }

    setCurrentPage(pageTotal - 1)
    props.onChangePage({
      selected: pageTotal,
    })
  }
  const onClick: ReactPaginateProps['onClick'] = (info) => {
    if (info.isBreak) {
      return false
    }
  }

  useEffect(() => {
    setCurrentPage(page - 1)
  }, [page])

  return {
    currentPage,
    pageTotal: pageTotal,
    isFirst,
    isLast,
    onChangePage,
    onClickFirst,
    onClickLast,
    onClick,
  }
}
